export const formatPrice = (value: number): string => {
  const val = (value).toFixed(2).replace('.', ',')
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}